export default __webpack_public_path__ + "static/media/main_item_01.b755ce63.png";